import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { pairingReducer } from './pairing.reducer';
import { PairingEffects } from './pairing.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('pairing', pairingReducer),
    EffectsModule.forFeature([PairingEffects]),
  ],
  providers: [],
})
export class PairingStoreModule {}
